






















































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import VueRouter from "vue-router";
import VeeValidate from "vee-validate";
import axios from "axios";
import ParticaTreeMenu from "@/Views/MainMenu/ParticaTreeMenu.vue";
import ParticaSnackbar from "./Ui-Components/Common/ParticaSnackbar/ParticaSnackbar.vue";
import ParticaLoader from "@/Ui-Components/Common/Loader/ParticaLoader.vue";
import EventBus from "./Plugins/eventbus";
import { eParticaAction, ParticaEvent } from "./Models/ParticaEvent";
import { AccountClient, IAccountClient, ISearchClient, SearchClient, ListItemDTO } from "./Generated/ParticaAPI";
import { mixins } from "vue-class-component";
import StateMixin from "./Mixins/StateMixin";
import ParticaCardFill from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
// @ts-ignore
import VueAzureUploader from "vue-azure-blob-upload";
// @ts-ignore
import VueGAPI from "vue-gapi";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";

const namespace: string = "config";

Vue.filter("toCurrency", (value: number) => {
	const formatter = new Intl.NumberFormat("en-AU", {
		style: "currency",
		currency: "AUD",
		minimumFractionDigits: 2
	});
	return formatter.format(value);
});

Vue.filter("truncate", (text: string, length: number, clamp: string) => {
	clamp = clamp || "...";
	const node = document.createElement("div");
	node.innerHTML = text;
	const content = node.textContent;
	// @ts-ignore
	return content.length > length ? content.slice(0, length) + clamp : content;
});

Vue.use(VueAzureUploader);
Vue.use(VeeValidate);


// create the 'options' object
const apiConfig: any = {
	clientId: "763558251550-hprrpfvs3qtsd7bl673c39b286b022nd.apps.googleusercontent.com",
	discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
	scope: "https://www.googleapis.com/auth/spreadsheets"
	// see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
};
// Use the plugin and pass along the configuration
Vue.use(VueGAPI, apiConfig);

@Component({
	components: { ParticaTreeMenu, ParticaSnackbar, ParticaLoader, ParticaRightDrawer, ParticaCardFill },
	mixins: [StateMixin]
})
export default class App extends Vue {
	private refreshKey: number = 0;
	private clipped: boolean = true;
	private drawer: boolean = true;
	private miniVariant: boolean = false;
	private right: boolean = true;
	private experimentalDecorators: boolean = true;
	private title: string = "Partica";
	private data: any = null;
	private items = [
		{ title: "Home", icon: "home", link: "/" },
		{ title: "Login", icon: "touch_app", link: "/login" },
		{ title: "Content Streams", icon: "get_app", link: "/contentstreams" }
	];
	private searchdrawer: boolean = false;
	private domainresults: ListItemDTO[] = [];
	private publicationresults: ListItemDTO[] = [];
	private issueresults: ListItemDTO[] = [];
	private query: string = "";

	private reloadPage() {
		this.refreshKey++;
	}
	private reloadMyAccount() {
		EventBus.$emit("main-menu-event", {
			action: eParticaAction.MY_MENU_RELOAD
		} as ParticaEvent);
	}
	private async logout() {
		localStorage.removeItem("auth");
		localStorage.removeItem("admin");
		localStorage.removeItem("user");
		this.settoken("");
		this.setaccount(-1);
		this.setcurrentid(0);
		const accountClient: IAccountClient = new AccountClient();
		await accountClient.logout();
		this.$router.push({ path: "/login" });
		this.reloadPage();
	}
	private hasToken() {
		if (localStorage.auth) { return true; }
		return false;
	}


	private async showsearch() {
		this.searchdrawer = true;
	}



	private async dosearch() {
		try {
			EventBus.$emit("loading-start");
			const searchClient: ISearchClient = new SearchClient();
			this.domainresults = await searchClient.searchDomain(this.query);
			this.publicationresults = await searchClient.searchPublication(this.query);
			this.issueresults = await searchClient.searchIssue(this.query);
		} catch (error) {
			console.log(error);
		} finally {
			EventBus.$emit("loading-end");
		}
	}


	private async created() {
		// little hacky getting api this way. TODO look at improving later.
		if (localStorage.auth) {
			this.settoken(localStorage.auth);
			axios.defaults.headers.common.Authorization = "Bearer " + localStorage.auth;
		}
		if (localStorage.admin) {
			const val: boolean = localStorage.admin === "true" ? true : false;
			this.setadmin(val);
		}
		if (localStorage.user) {
			this.setuser(localStorage.user);
		}

		this.setapiroot(this.$parent.$data.env.apiRoot);
		this.setthumburl(this.$parent.$data.env.thumbUrl);
		this.setstore(this.$parent.$data.env.storeUrl);

		this.$router.beforeEach((to, from, next) => {
			EventBus.$emit("loading-start");
			if (
				(axios.defaults.headers.common.Authorization === null &&
					to.name !== "login") === true
			) {
				next({ name: "login", params: { from: to.path } });
			} else {
				next();
			}
		});
		this.$router.afterEach((to, from) => {
			EventBus.$emit("loading-end");
		});
	}

	private selectdomain(item: ListItemDTO) {
		this.$router.push({ path: `/website/${item.id}/` });
	}
	private selectpublication(item: ListItemDTO) {
		this.$router.push({ path: `/title/${item.id}/` });
	}
	private selectissue(item: ListItemDTO) {
		this.$router.push({ path: `/pubissue/${item.id}/` });
	}
}
